import * as React from 'react'
function SvgAttach(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M23.07 29.976c-3.011 3.012-7.717 3.012-10.729 0-3.012-3.011-3.2-7.529-.188-10.352l8.47-8.471c1.883-1.882 4.895-1.882 6.589 0 1.882 1.882 1.882 4.894 0 6.588l-6.588 6.777c-.753.753-1.883.753-2.636 0-.753-.753-.753-1.883 0-2.636l3.905-3.905a1.866 1.866 0 00-.046-2.683 1.999 1.999 0 00-2.777.048l-3.717 3.717c-2.259 2.259-2.259 5.835 0 7.906 2.259 2.07 5.835 2.259 7.906 0l6.776-6.777c3.389-3.388 3.389-8.659 0-12.047-3.388-3.388-8.659-3.388-12.047 0l-8.47 8.847c-4.33 4.33-4.142 11.294.188 15.624C11.965 34.87 14.788 36 17.8 36c3.012 0 5.835-1.13 7.906-3.388l6.776-6.777a1.863 1.863 0 10-2.635-2.635l-6.776 6.776z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgAttach
